import cloneDeep from 'lodash/fp/cloneDeep';
import { provideService } from '@/services/provider';
import SpotlightConstants from '@/utils/enums/spotlightConstants';

const initialState = {
  payload: {
    sirius_xm: null,
  },
  categories: [],
  heroes: [],
  vendorList: ['canadian', 'sirius', 'lubrico', 'ia', 'auto-shield', 'global-warranty'], // TEMPORARY HARD-CODED LIST UNTIL PAYLOAD GIVES US IS_VENDOR INFO
};
const getters = {
  sxmEquipped: state => !!state.payload.sirius_xm,
  hasSxmProgram: state => !!state.payload.sirius_xm && !!state.payload.sirius_xm.duration,
  sxmPayload: state => state.payload.sirius_xm || null,
  totalSpotlightCardCount: state => state.categories.length + state.heroes.length,
  getSpotlightHeroes: state => state.heroes,
  getSpotlightCategories: state => state.categories,
  getProductList: state => category =>
    state.categories.find(payload => payload.category === category)?.spotlights || [],
  getVendorList: state => state.vendorList,
};
const mutations = {
  SET_SPOTLIGHT_PAYLOAD(state, payload) {
    state.payload = payload;
  },
  SET_STATE(state, [key, data]) {
    state[key] = data;
  },
};
const actions = {
  async fetchSpotlights({ rootState, commit }, { language, vin, condition, make, mileage, price }) {
    const isDemo = process.env.VUE_APP_APP_ENV === 'test';
    const spotlightService = provideService({
      product: 'spotlight',
      isDemo,
    });

    const { business } = rootState;

    const options = {
      params: {
        api_key: business.api.key,
        external_id: business.api.externalID,
        vin,
        condition,
        make,
        language,
        mileage,
        price,
      },
    };

    const responseStatus = {
      FULFILLED: 'fulfilled',
      REJECTED: 'rejected',
    };

    const heroes = spotlightService.fetchSpotlightHeroes({ options });
    const categories = spotlightService.fetchSpotlightCategories({ options });

    // The APIs are not dependent on each other
    const [heroesRes, categoriesRes] = await Promise.allSettled([heroes, categories]);

    if (heroesRes.status === responseStatus.FULFILLED) {
      // TODO: Remove this modification when SXM is under features
      const modifiedHeroes = heroesRes.value.data.map(hero => {
        if (hero.internalName === SpotlightConstants.internalNames.siriusXm['VEHICLE-PROGRAM']) {
          return {
            ...hero,
            category: SpotlightConstants.categories.HIGHLIGHTS,
          };
        }

        return hero;
      });
      commit('SET_STATE', ['heroes', modifiedHeroes]);

      // This is temporary for the existing Spotlight users
      const siriusXmSpotlight = heroesRes.value.data.filter(
        spotlight => spotlight.internalName === SpotlightConstants.internalNames.siriusXm['VEHICLE-PROGRAM']
      );
      if (siriusXmSpotlight.length > 0) {
        commit('SET_SPOTLIGHT_PAYLOAD', { sirius_xm: { ...siriusXmSpotlight[0].payload } });
      }
    }

    if (categoriesRes.status === responseStatus.FULFILLED) {
      // TODO: Remove this modification when SXM is under features
      const siriusXmIndex = categoriesRes.value.data.findIndex(
        value => value.category === SpotlightConstants.categories.FEATURES
      );
      let modifiedCategories = categoriesRes.value.data;

      if (siriusXmIndex !== -1) {
        // New payload without features
        modifiedCategories = categoriesRes.value.data.filter(
          value => value.category !== SpotlightConstants.categories.FEATURES
        );
        const highlightsIndex = modifiedCategories.findIndex(
          value => value.category === SpotlightConstants.categories.HIGHLIGHTS
        );
        const siriusXmSpotlight = {
          ...categoriesRes.value.data[siriusXmIndex].spotlights[0],
          category: SpotlightConstants.categories.HIGHLIGHTS,
        };

        if (highlightsIndex !== -1) {
          // If highlights category exists, add siriusXM to the highlights spotlights array
          modifiedCategories[highlightsIndex].spotlights.unshift(siriusXmSpotlight);
        } else {
          // No highlights category found, create a new highlights category
          modifiedCategories.unshift({
            category: SpotlightConstants.categories.HIGHLIGHTS,
            spotlights: [siriusXmSpotlight],
          });
        }
      }
      commit('SET_STATE', ['categories', modifiedCategories]);
    }
  },
};

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  mutations,
  actions,
  getters,
};
